import { memo, useState } from 'react';

import { UserPopover } from '@bonusly/common-user-popover';
import { Box, useBreakpointValue, useDisclosure } from '@bonusly/design-system';

import { ProfileLink } from '../../../../../modules/profile/components/profile-link';
import { Bonus } from '../../../../../types/bonus';
import { UserAvatar } from '../../components/user-avatar';
import { BonusFeedTrackedAction, useTrackBonusFeedItemEvent } from '../../hooks/use-bonus-feed-item-analytics';
import { CommentDisplay } from './comment-display';
import { CommentEditor } from './comment-editor';
import { ScrollToCommentData } from './hooks/use-scroll-to-comment';

interface CommentProps {
	bonus: Bonus;
	parentBonus: Bonus;
	scrollTo?: ScrollToCommentData;
}

export const Comment = memo(({ bonus, parentBonus, scrollTo }: CommentProps) => {
	const { isOpen: isEditing, onClose, onOpen } = useDisclosure();
	const { giver } = bonus;
	const trackAvatarClick = useTrackBonusFeedItemEvent(bonus, BonusFeedTrackedAction.AvatarClick);

	const [hasScrolledTo, setHasScrolledTo] = useState(false);
	if (scrollTo?.scrollToAction && !hasScrolledTo) {
		setHasScrolledTo(true);
		setTimeout(scrollTo.scrollToAction, 500);
		setTimeout(scrollTo.scrollToAction, 1500);
		setTimeout(scrollTo.scrollToAction, 2500);
	}

	const sizes = useBreakpointValue({ base: 'sm' as any, xs: 'md' as any });

	return (
		<Box display="flex" data-testid="comment" ref={scrollTo?.commentRef}>
			<UserPopover userId={giver.id}>
				<ProfileLink userId={giver.id}>
					<UserAvatar user={giver} onClick={trackAvatarClick} size={sizes} />
				</ProfileLink>
			</UserPopover>

			{isEditing ? (
				<CommentEditor bonus={bonus} onDone={onClose} parentBonus={parentBonus} />
			) : (
				<CommentDisplay bonus={bonus} parentBonus={parentBonus} onEdit={onOpen} highlightColor={scrollTo?.highlightColor} />
			)}
		</Box>
	);
});

Comment.displayName = 'Comment';
